import React from 'react';
import SectionCard from './SectionCard';
import { experiencesData } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const ExperienceSection = ({ isDoorOpen }) => {
  const { t, language } = useLanguage();

  // Get experiences for current language
  const experiences = experiencesData[language] || experiencesData.fr;

  return (
    <SectionCard
      id="experiences"
      icon="📂"
      title={t.experience.title}
      subtitle={t.experience.subtitle}
      isDoorOpen={isDoorOpen}
    >
      {experiences.map((exp) => (
        <div key={exp.id} className="exp-item">
          <div className="exp-title">{exp.title}</div>
          <div className="exp-meta">
            {exp.period} · {exp.company} · {exp.location}
          </div>
          {exp.tagline && <p className="tagline">{exp.tagline}</p>}
          <ul>
            {exp.tasks.map((task, index) => (
              <li key={index}>{task}</li>
            ))}
          </ul>
        </div>
      ))}
    </SectionCard>
  );
};

export default ExperienceSection;
